import { GameProviderItem } from '@/components/pages/casino/GameProviders/game-providers';
import { providerList, useValidProviders } from '@/components/pages/casino/GameProviders/helper';
import { Box } from '@mui/material';

const ProvidersPage = () => {
  const validProviders = useValidProviders(providerList);

  return (
    <Box>
      <h1>Providers</h1>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', // Adjust the minmax values based on your item size
          gap: 1, // Adjust the gap size as needed
        }}
      >
        {validProviders.map((provider) => {
          return <GameProviderItem key={provider.name} provider={provider} />;
        })}
      </Box>
    </Box>
  );
};

export default ProvidersPage;